export default {
  preventRedirect: {
    message: "Are you sure you want to leave without saving data?",
  },
  buttons: {
    cancel: "Cancel",
    confirm: "Confirm",
  },
};
